import { render, staticRenderFns } from "./TeamInviteAcceptDecline.vue?vue&type=template&id=5b9da177&scoped=true"
import script from "./TeamInviteAcceptDecline.vue?vue&type=script&lang=js"
export * from "./TeamInviteAcceptDecline.vue?vue&type=script&lang=js"
import style0 from "./TeamInviteAcceptDecline.vue?vue&type=style&index=0&id=5b9da177&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9da177",
  null
  
)

export default component.exports